module.exports = "<p>\n  digi-result works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/digi/digi-result/digi-result.component.html
// module id = ./src/app/digi/digi-result/digi-result.component.html
// module chunks = main